// react
import { useTranslation } from 'react-i18next';

// types
import { Project, StatsEvidence } from '../../../../@types';

// mui
import { Grid, Typography } from '@mui/material';

// ui
import { IconCircle } from '../../../ui/IconCircle/IconCircle';
import { Table, TableHeader, TableProps } from '../../../ui/Table/Table';

// links
import { LinkProject } from '../../../links/LinkProject/LinkProject';

// props
export interface TableBasicProjectsEvidenceProps extends Omit<TableProps, 'headers'> {
	data: StatsEvidence[];
}

const formatAmount = (value: number): string =>
	Number(value).toLocaleString(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

export const TableBasicProjectsEvidence = ({
	data = [],
	...props
}: TableBasicProjectsEvidenceProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const headers: TableHeader[] = [
		{
			isSortable: true,
			label: t('project'),
			render: (_: unknown, __: TableHeader, row: StatsEvidence) => (
				<Grid alignItems="center" container spacing={1} wrap="nowrap">
					<Grid item>
						<IconCircle
							size="xs"
							TooltipProps={{
								componentsProps: { tooltip: { sx: { maxWidth: 160 } } },
								title: row.project,
							}}
							type="project"
						/>
					</Grid>
					<Grid flex={1} item>
						<LinkProject
							children={row.idWbg}
							project={{ idWbg: row.idWbg, name: row.project } as Project}
							sx={{ whiteSpace: 'nowrap' }}
						/>
					</Grid>
				</Grid>
			),
			value: 'idWbg',
		},
		{
			isSortable: true,
			label: t('name'),
			render: (_: unknown, __: TableHeader, row: StatsEvidence) => (
				<Typography sx={{ whiteSpace: 'nowrap' }}>{row.project}</Typography>
			),
			value: 'name',
		},
		{
			label: t('evidencedCategory'),
			render: (_: unknown, __: TableHeader, row: StatsEvidence) => (
				<Typography>{row.evidenceCategory}</Typography>
			),
			value: 'evidenceCategory',
		},
		{
			label: t('currency'),
			render: (_: unknown, __: TableHeader, row: StatsEvidence) => (
				<Typography>{row.currency ?? '-'}</Typography>
			),
			value: 'currency',
		},
		{
			label: t('amount'),
			render: (_: unknown, __: TableHeader, row: StatsEvidence) => (
				<Typography>{formatAmount(row.totalAmount)}</Typography>
			),
			value: 'totalAmount',
		},
	];

	return <Table color="grey" {...props} data={data} headers={headers} />;
};
